import { StatusModel } from '../general';
import { PeripheralTopicItemModel } from '../shared/components/peripheral-topic-item';

export interface PeripheralMetricsModel {
  utilisation: StatusModel;
  series: Pick<PeripheralTopicItemModel, 'id' | 'title' | 'icon' | 'children'>;
}

export interface PeripheralChildModel {
  name: string;
  value: string;
  type: string;
}
